import { defineComponent as a, ref as c, createBlock as n, openBlock as o, withCtx as r, createVNode as m, createCommentVNode as i, resolveDynamicComponent as l } from "vue";
import s from "../../components/ViewLayout/ViewLayout.vue.js";
import _ from "../../components/ViewLayout/ViewLayoutContent.vue.js";
import f from "./SettingsGeneral.vue.js";
const k = /* @__PURE__ */ a({
  __name: "Settings",
  setup(p) {
    const e = {
      general: {
        component: f,
        title: "general"
      }
    }, t = c("general");
    return (u, d) => (o(), n(s, null, {
      default: r(() => [
        m(_, { class: "flex-1" }, {
          default: r(() => [
            e[t.value] ? (o(), n(l(e[t.value].component), { key: 0 })) : i("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
});
export {
  k as default
};
